import actionCreatorFactory from 'typescript-fsa';

import { FilterCountsResponse } from '@shared/types/mylounge/filterCounts';

import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const fetchingFilters = actionCreator.async<null, FilterCountsResponse, string>(
    'FETCH_FILTERS',
);
